module.exports = __webpack_public_path__ + "static/media/image1.45a3a304.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/image1.jpg
// module id = 646
// module chunks = 0